import {
  SUPER_ADMIN_UPDATE_USER_FIELD_ERROR,
  SUPER_ADMIN_UPDATE_USER_FIELD_SUCCESS,
} from '../types';

type UserFieldErrorState = string | null;

interface UserFieldErrorAction {
  type: string;
  message: string;
}

const initialState: UserFieldErrorState = null;

const userFieldError = (
  state: UserFieldErrorState = initialState,
  action: UserFieldErrorAction,
): UserFieldErrorState => {
  switch (action.type) {
    case SUPER_ADMIN_UPDATE_USER_FIELD_ERROR:
      return action.message;
    case SUPER_ADMIN_UPDATE_USER_FIELD_SUCCESS:
      return null;
    default:
      return state;
  }
};

export default userFieldError;
